module.exports = __webpack_public_path__ + "static/media/bar_chart.788c2a89.png";